<template>
  <ul
    v-if="items"
    :class="$style.list"
  >
    <li
      v-for="item in items"
      :key="item.id"
      :class="$style.listItem"
    >
      <slot
        name="item"
        :item="item"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ListOfButtons',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="less" module>
.list {
  margin: 0;
  padding: 0;
  list-style: none inside none;
}
.listItem + .listItem {
  margin-top: 10px;
}
</style>

<i18n lang="json">{}</i18n>
